<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded" class="main-offer-card">
      <!-- <div class="summary-title">
        <div class="summary-icon-sample-details"></div>
        <div class="summary-text">{{ $t('sample_detail') }}</div>
      </div> -->
      <div class="summary-header">
        <div class="summary-title">
          <div class="summary-icon-sample-details"></div>
          <div class="summary-text">{{ $t('sample_detail') }}</div>
        </div>

        <div class="summary-actions">
          <button
            class="download-button"
            @click="$refs.sampleSummary.download()"
          >
            {{ $t('download') }}
          </button>
          <!-- Puedes agregar más botones aquí más adelante -->
        </div>
      </div>
      <div v-if="!isFinished" class="warning-message">
        {{ $t('provisionalResultsMessage') }}
      </div>

      <!-- <AgronomySampleSummary /> -->
      <AgronomySampleSummary ref="sampleSummary" />

      <!-- AGROIA_AGUAS_ONLY: AgroIA se habilita para toda muestra agronómica terminada; en Aguas, solo para Agua Riego. -->
      <AgroIAChatbot v-if="canShowAgroIA" />

      <br />
      <div
        class="custom-table-container-agro-details tableContainerAgro"
      >
        <AgronomySampleDetail v-if="showDetails" />
      </div>
      <NotificationSpinner
        v-if="!showDetails"
        :message="$t('pendingPaymentSampleResult')"
        :alert="true"
      />

      <!-- <NotificationSpinner
        v-if="inProcess"
        :message="$t('inProcessSampleResult')"
        :warning="true"
      /> -->
    </div>
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AgronomySampleSummary from '@/components/Agronomy/AgronomySampleSummary/index.vue';
import AgroIAChatbot from '@/components/Agronomy/AgroIAChatbot/index.vue';
import NotificationSpinner from '@/components/NotificationSpinner/index.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import AgronomySampleDetail from '../../../components/Agronomy/AgronomySampleDetail/AgronomySampleDetail.vue';

export default {
  components: {
    AgronomySampleDetail,
    AgronomySampleSummary,
    AgroIAChatbot,
    NotificationSpinner,
  },
  data() {
    return {
      loaded: false,
      currentSampleSummary: {},
    };
  },
  computed: {
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      // Si accede al detalle de una muestra desde una factura, vuelve al listado de facturas
      if (this.lastRouteIssuedInvoicesList) {
        return 'issuedInvoicesList';
      }
      return this.lastRouteHome ? 'Home' : 'AgronomySamplesPage';
    },
    showDetails() {
      return this.currentSampleSummary?.status_code !== '5';
    },
    inProcess() {
      return this.currentSampleSummary?.status_code === '2';
    },
    isFinished() {
      return this.currentSampleSummary?.status_code === '3';
    },
    // AGROIA_AGUAS_ONLY: todas las muestras agronómicas terminadas pueden usar
    // AgroIA; la restricción de Agua Riego solo aplica dentro de la familia Aguas.
    canShowAgroIA() {
      const sample = this.currentSampleSummary || {};
      const normalize = (value) =>
        String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toUpperCase();
      const sampleType = normalize(
        sample.sample_type || sample.sampleType
      );
      const sampleFamily = normalize(
        sample.sample_type_family ||
          sample.sampleTypeFamily ||
          sample.family
      );
      const familyId = Number(
        sample.sample_type_family_id ||
          sample.sampleTypeFamilyId ||
          sample.family_id
      );

      const isAguaRiego = sampleType === 'AGUA RIEGO';
      const isWaterFamily =
        familyId === 4 || sampleFamily === 'AGUAS';

      return this.isFinished && (!isWaterFamily || isAguaRiego);
    },
    // showNotificationSpinner() {
    //   return this.currentSampleSummary?.status_code === '5';
    // },
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteGeotoolboxSamples',
      'lastRouteIssuedInvoicesList',
      'sampleDetailReloadInProgress',
    ]),
  },
  async beforeMount() {
    try {
      this.loaded = false;
      this.currentSampleSummary =
        await this.getCurrentSampleBasedOnFilter();
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('sample_detail'),
          disabled: true,
          page: 'AgronomySamplesDetailsPage',
          active: true,
        },
      ]);
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    }
  },
  async mounted() {
    try {
      this.loaded = false;
      await this.getSampleDetails(this.currentSampleId);
    } catch (error) {
      const msg = JSON.parse(error.message);
      if (msg.data && msg.data.length === 0) {
        this.setSampleDetails(msg.data);
        return;
      }

      this.$notifyDX(
        {
          message: error,
          width: 350,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
      if (this.sampleDetailReloadInProgress) {
        this.setSampleDetailReloadInProgress(false);
      }
    }

    // if (!this.showDetails) {
    //   this.$notifyDX(
    //     {
    //       message: this.$t('pendingPaymentSampleResult'),
    //       width: 550,
    //     },
    //     'warning',
    //     7000
    //   );
    // }
  },
  methods: {
    ...mapActions('agronomySamples', [
      'getSampleDetails',
      'setSampleDetails',
    ]),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('samples', [
      'getCurrentSampleBasedOnFilter',
      'setSampleDetailReloadInProgress',
    ]),
  },
};
</script>
<style scoped>
.tableContainerAgro {
  background: var(--Basic-White, #fff) !important;
  border-radius: 10px !important;
}
.tableContainerAgro > div[style*='position: absolute'] {
  right: 70px !important;
}
/* El card rojo: puedes dejarlo como lo tienes */
.main-offer-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  margin-top: 16px;
  border: none;
  /* Evita que algo que se pase se vea fuera */
  overflow-x: clip; /* fallback: hidden */
}

/* Tu contenedor del grid */

/* ========== OVERRIDES DEVEXTREME (necesitan deep) ========== */

/* 1) El header panel ocupa exactamente el ancho del contenedor */
.custom-table-container .dx-datagrid-header-panel {
  width: 100% !important;
  box-sizing: border-box;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-right: 0 !important; /* neutraliza posibles márgenes del tema */
  overflow: hidden; /* corta cualquier “salto” raro */
}

/* 2) El toolbar no añade márgenes y puede encogerse dentro del card */
.custom-table-container .dx-datagrid-header-panel .dx-toolbar,
.custom-table-container
  .dx-datagrid-header-panel
  .dx-toolbar-items-container {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 3) Zona derecha del toolbar (donde van buscador y filtro):
      - puede encogerse
      - se alinea a la derecha
      - no empuja fuera del card */
::v-deep
  .custom-table-container
  .dx-datagrid-header-panel
  .dx-toolbar-after {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0; /* CLAVE: permite que los hijos se encojan sin desbordar */
  overflow: hidden;
  padding-right: 0 !important;
  margin-right: 0 !important;
}

/* 4) El buscador puede reducirse y nunca se sale del 100% */
::v-deep
  .custom-table-container
  .dx-datagrid-header-panel
  .dx-datagrid-search-panel {
  flex: 0 1 260px; /* ancho base 260px pero puede encoger */
  max-width: 100% !important;
}

/* 5) El botón de filtro no reserva más ancho del necesario */
::v-deep
  .custom-table-container
  .dx-datagrid-header-panel
  .dx-toolbar-after
  .dx-toolbar-item {
  flex: 0 0 auto;
  margin-right: 0 !important; /* que no añada margen extra a la derecha */
}

.custom-table-container {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  box-sizing: border-box;
}

.summary-title {
  gap: 10px;
  margin-bottom: 16px;
}

.summary-icon-sample-details {
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/ic_detalle_muestra.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #04509f;
}

.summary-header {
  align-items: baseline;
  margin-bottom: 16px;
}

.summary-title {
  gap: 10px;
}

.summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Botón “Descargar” fuera del card */
.download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #00346a;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 10px;
  padding: 10px 14px 10px 34px;
  cursor: pointer;
  background-image: none;
  background-repeat: no-repeat;
  background-position: 10px center;
  background-size: 16px;
}

.download-button:hover {
  background-color: #004b93;
}
.summary-actions .download-button {
  transform: translateY(
    -6px
  ); /* súbelo ligeramente para alinearlo con el icono */
}

.warning-message {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #bc5b00;
  background: #fff2e5;
  color: #bc5b00;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  padding: 8px 16px 8px 42px; /* espacio para el icono */
  margin-bottom: 16px;
  background-image: url('@/static/icons/warning.svg'); /* tu icono */
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: 14px center; /* posición del icono */
}

.download-button:disabled {
  background-color: #e5e4e7; /* gris claro como en Figma */
  color: #8a8693; /* gris del texto e icono */
  cursor: not-allowed;
  border: 1px solid #8a8693; /* borde fino gris */
  filter: none; /* evita efectos de hover */
  opacity: 1; /* mantiene visibilidad */
}

.download-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #00346a;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 10px 18px 10px 46px;
  cursor: pointer;
  font-size: 14px;
}

.download-button::before {
  content: '';
  position: absolute;
  left: 14px;
  width: 24px; /* tamaño del icono */
  height: 24px;
  background-image: url('@/static/icons/download.svg');
}
</style>
